let prebid = require('./adv/prebidLoader.js');
prebid.init();


let dfp = require('./adv/dfpLoader.js');
dfp.init();